<template>
  <div class="section mt-1">
    <div class="tab-container-1">
      <nav class="pill-tabs" aria-label="Member Categories">
        <button class="pill-tab" :class="{ active: wing === 1 }" @click="getMembersList(1)" type="button">
          {{ $t('members') }}
        </button>
        <button class="pill-tab" :class="{ active: wing === 2 }" @click="getMembersList(2)" type="button">
          {{ $t('executives') }}
        </button>
      </nav>
    </div>
  </div>

  <div class="modal fade action-sheet" id="addMemberModel" tabindex="-1" role="dialog" v-if="wing === 1">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('member_details') }}</h5>
        </div>
        <div class="modal-body">
          <div class="action-sheet-content">
            <Form @submit="addMember" :validation-schema="validationSchema">
              <div class="form-group basic" v-if="currentUser.user_level <= 1">
                <div class="input-wrapper">
                  <label class="label text-primary" for="district">{{ $t('district') }} <span class="mal-text"></span></label>
                  <Field as="select" class="form-control custom-select" v-model="district_" name="district" id="select2"
                    @change="onDistrictChange($event.target.value)">
                    <option value="" selected>---{{ $t('select') }}---</option>
                    <option v-for="district in district_list" v-bind:key="district.id" :value="district.id">
                      {{ district.name }}</option>
                  </Field>
                </div>
                <ErrorMessage name="district" class="error-feedback" />
              </div>
              <div class="form-group basic" v-if="currentUser.user_level <= 2">
                <div class="input-wrapper">
                  <label class="label text-primary" for="zone">{{ $t('zone') }} <span class="mal-text"></span></label>
                  <Field as="select" class="form-control custom-select" v-model="zone_" name="zone" id="select4"
                    @change="onZoneChange($event.target.value)">
                    <option value="" selected>---{{ $t('select') }}---</option>
                    <option v-for="zone in zone_list" v-bind:key="zone.id" :value="zone.id">
                      {{ zone.name }}</option>
                  </Field>
                </div>
                <ErrorMessage name="zone" class="error-feedback" />
              </div>
              <div class="form-group basic" v-if="currentUser.user_level <= 3">
                <div class="input-wrapper">
                  <label class="label text-primary" for="unit">{{ $t('unit') }} <span class="mal-text"></span></label>
                  <Field as="select" class="form-control custom-select" v-model="unit_" name="unit" id="select4">
                    <option value="" selected>---{{ $t('select') }}---</option>
                    <option v-for="unit in unit_list" v-bind:key="unit.id" :value="unit.id">
                      {{ unit.name }}</option>

                  </Field>
                </div>
                <ErrorMessage name="unit" class="error-feedback" />
              </div>
              <div class="form-group basic">
                <label class="label" for="name">{{ $t('name') }}</label>
                <Field name="name" type="text" class="form-control" id="name" v-model="formData.name"
                  :placeholder="$t('enter_name')" autocomplete="off" />
                <ErrorMessage name="name" class="error-feedback" />
              </div>

              <div class="form-group basic">
                <label class="label" for="father_name">{{ $t('father_name') }}</label>
                <Field name="father_name" type="text" class="form-control" id="father_name" v-model="formData.father_name"
                  :placeholder="$t('enter_father_name')" autocomplete="off" />
                <ErrorMessage name="father_name" class="error-feedback" />
              </div>

              <div class="form-group basic">
                <label class="label" for="age">{{ $t('age') }}</label>
                <Field name="age" type="number" class="form-control" id="age" v-model="formData.age"
                  :placeholder="$t('enter_age')" autocomplete="off" min="1" max="150" />
                <ErrorMessage name="age" class="error-feedback" />
              </div>

              <div class="form-group basic">
                <label class="label" for="school_name">{{ $t('school_name') }}</label>
                <Field name="school_name" type="text" class="form-control" id="school_name" v-model="formData.school_name"
                  :placeholder="$t('enter_school_name')" autocomplete="off" />
                <ErrorMessage name="school_name" class="error-feedback" />
              </div>

              <div class="form-group basic">
                <label class="label" for="school_class">{{ $t('class') }}</label>
                <Field name="school_class" type="text" class="form-control" id="school_class" v-model="formData.school_class"
                  :placeholder="$t('enter_class')" autocomplete="off" />
                <ErrorMessage name="school_class" class="error-feedback" />
              </div>

              <div class="form-group basic">
                <div class="input-wrapper row">
                  <label class="label" for="country_code">
                    {{ $t('mobile_number') }}
                  </label>
                  <div class="form-group" style="width:30% !important;">
                    <div class="input-wrapper">
                      <Field as="select" class="form-control custom-select" v-model="formData.countryCode"
                        name="country_code" id="countryCodeSelect" @change="onCountryCodeChange">
                        <option v-for="item in countryCodeList" :key="item.item_value" :value="item.item_value">
                          {{ item.name }}
                        </option>
                      </Field>
                    </div>
                  </div>
                  <div class="form-group mobile-field" style="width:68% !important; margin-left: 2%;">
                    <div class="input-wrapper">
                      <Field name="mobile" type="tel" id="mobile" class="form-control" placeholder="" autocomplete="off"
                        v-model="formData.mobile" @input="formatMobileNumber" />
                    </div>
                  </div>
                  <ErrorMessage name="mobile" class="error-feedback" />
                </div>
              </div>

              <div class="form-group basic">
                <div class="input-wrapper row">
                  <label class="label" for="whatsapp_country_code">
                    {{ $t('whatsapp_number') }}
                  </label>
                  <div class="form-group" style="width:30% !important;">
                    <div class="input-wrapper">
                      <Field as="select" class="form-control custom-select" v-model="formData.whatsappCountryCode"
                        name="whatsapp_country_code" id="whatsappCountryCodeSelect">
                        <option v-for="item in countryCodeList" :key="item.item_value" :value="item.item_value">
                          {{ item.name }}
                        </option>
                      </Field>
                    </div>
                  </div>
                  <div class="form-group mobile-field" style="width:68% !important; margin-left: 2%;">
                    <div class="input-wrapper">
                      <Field name="whatsapp" type="tel" id="whatsapp" class="form-control" placeholder=""
                        autocomplete="off" v-model="formData.whatsapp" @input="formatWhatsAppNumber" />
                    </div>
                  </div>
                  <ErrorMessage name="whatsapp" class="error-feedback" />
                </div>
              </div>

              <div class="form-group basic">
                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading"
                  v-if="canUpdateMembers">
                  <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                  <span>{{ isEditing ? $t('update') : $t('save') }}</span>
                </button>
                <button type="button" class="btn btn-primary btn-block btn-lg" v-if="!canUpdateMembers"
                  @click="closeAddMemberModal">
                  {{ $t('close') }}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade action-sheet" id="addExecutiveModel" tabindex="-1" role="dialog" v-if="wing === 2">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('balavedi_teams') }}</h5>
        </div>
        <div class="modal-body">
          <div class="action-sheet-content">
            <Form @submit="addExecutive" :validation-schema="executiveValidationSchema">
              <!-- Captain Selection -->
              <div class="form-group basic">
                <div class="input-wrapper">
                  <label class="label text-primary" for="captain">
                    {{ $t('captain') }}
                  </label>
                  <Field as="select" class="form-control custom-select" v-model="executiveFormData.captain" 
                    name="captain" id="captainSelect">
                    <option value="">---{{ $t('select-captain') }}---</option>
                    <option v-for="member in availableMembers" :key="member.id" :value="member.id"
                      :disabled="isCurrentlyAssigned(member.id, 'captain')">
                      {{ member.name }}
                    </option>
                  </Field>
                </div>
                <ErrorMessage name="captain" class="error-feedback" />
                <small class="form-text text-muted" v-if="currentCaptain">
                  {{ $t('current_captain') }}: {{ currentCaptain.name }}
                </small>
              </div>

              <!-- Vice Captain Selection -->
              <div class="form-group basic">
                <div class="input-wrapper">
                  <label class="label text-primary" for="vice_captain">
                    {{ $t('vice_captain') }}
                  </label>
                  <Field as="select" class="form-control custom-select" v-model="executiveFormData.vice_captain" 
                    name="vice_captain" id="viceCaptainSelect">
                    <option value="">---{{ $t('select-vice-captain') }}---</option>
                    <option v-for="member in availableMembers" :key="member.id" :value="member.id"
                      :disabled="isCurrentlyAssigned(member.id, 'vice_captain') || executiveFormData.captain == member.id">
                      {{ member.name }}
                    </option>
                  </Field>
                </div>
                <ErrorMessage name="vice_captain" class="error-feedback" />
                <small class="form-text text-muted" v-if="currentViceCaptain">
                  {{ $t('current_vice_captain') }}: {{ currentViceCaptain.name }}
                </small>
              </div>

              <!-- Team Members Selection (Multiple) -->
              <div class="form-group basic">
                <div class="input-wrapper">
                  <label class="label text-primary" for="team_members">
                    {{ $t('team_members') }} - {{ $t('maximum_7_allowed') }}
                  </label>
                  <div class="member-selection-container">
                    <div v-for="member in availableMembers" :key="member.id" class="member-checkbox-item">
                      <label class="checkbox-label">
                        <input type="checkbox" 
                          :value="member.id" 
                          v-model="executiveFormData.team_members"
                          :disabled="isTeamMemberDisabled(member.id)"
                          @change="onTeamMemberChange">
                        <span class="checkmark"></span>
                        <span class="member-info">
                          {{ member.name }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <small class="form-text text-muted">
                  {{ $t('selected') }}: {{ executiveFormData.team_members.length }}/7 {{ $t('members') }}
                </small>
                <small class="form-text text-danger" v-if="executiveFormData.team_members.length > 7">
                  {{ $t('max_allowed') }}
                </small>
              </div>

              <!-- Submit Button -->
              <div class="form-group basic">
                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading"
                  v-if="canUpdateMembers">
                  <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                  <span>{{ $t('save') }}</span>
                </button>
                <button type="button" class="btn btn-primary btn-block btn-lg" v-if="!canUpdateMembers"
                  @click="closeAddExecutiveModal">
                  {{ $t('close') }}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade action-sheet" id="deleteMemberModel" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('delete_member') }}</h5>
        </div>
        <div class="modal-body">
          <div class="action-sheet-content">
            <div class="form-group" v-if="deleteMessage">
              <div class="error-feedback">{{ deleteMessage }}</div>
            </div>

            <div class="form-group basic">
              <label class="label" for="deleteReason">
                <span class="mal-text">{{ $t('reason_to_delete') }}</span>
              </label>
              <div class="form-group boxed">
                <div class="input-wrapper mal-text">
                  <select class="form-control custom-select" v-model="deleteData.reason" name="deleteReason"
                    id="deleteReasonSelect" @change="onDeleteReasonChange">
                    <option value="">{{ $t('select_reason') }}</option>
                    <option v-for="reason in deleteReasons" :key="reason.value" :value="reason.value">
                      {{ reason.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="form-group basic" v-if="showOtherReasonField">
              <label class="label" for="otherReason">
                <span class="mal-text">{{ $t('reason_to_delete') }}</span>
              </label>
              <div class="form-group boxed">
                <input type="text" class="form-control" v-model="deleteData.otherReason" :placeholder="$t('reason_to_delete_explain')"
                  autocomplete="off" />
              </div>
            </div>

            <div class="form-group basic">
              <button type="button" @click="confirmMemberDelete" class="btn btn-primary btn-block btn-lg"
                :disabled="loading">
                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                <span>{{ $t('delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section pt-1 mt-1">
    <div class="balavedi-members-toolbar">
      <form class="search-form balavedi-members-toolbar-search" @submit.prevent>
        <div class="form-group searchbox mb-0">
          <input type="text" class="form-control" :placeholder="$t('search')" v-model="searchQuery"
            @input="filterMembers">
          <i class="input-icon">
            <ion-icon name="search-outline"></ion-icon>
          </i>
        </div>
      </form>

      <div class="balavedi-members-toolbar-actions">
        <button
          type="button"
          class="btn btn-outline-primary btn-sm balavedi-toolbar-btn"
          v-if="wing === 1 && hasUnpaidMembers"
          @click="togglePaymentSelectMode"
        >
          {{ paymentSelectMode ? $t('cancel') : $t('select') }}
        </button>
        <button
          type="button"
          class="btn btn-success btn-sm balavedi-toolbar-btn"
          v-if="wing === 1 && selectedMemberIds.length"
          @click="goToBulkPayment"
        >
          <ion-icon name="card-outline"></ion-icon>
          <span>{{ $t('make_payment') }} ({{ selectedMemberIds.length }})</span>
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm balavedi-toolbar-btn"
          @click="openAddModal"
          v-if="canUpdateMembers"
          :title="wing === 1 ? 'Add Member' : 'Add Executive'"
        >
          <ion-icon name="add-outline"></ion-icon>
          <span>{{ wing === 1 ? $t('new') : $t('add') }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="section text-center mt-2" v-if="loadingList">
    <div class="spinner-border text-secondary" role="status"></div>
  </div>

  <ul class="listview image-listview inset text mt-0 mb-2 mt-2" v-if="!loadingList && wing === 1 && filteredMembersList.length">
    <li v-for="(member, index) in filteredMembersList" :key="member.id"
      :style="{ 'background-color': getMemberBackgroundColor(member) }">
      <div class="item" :class="{ 'item-selected': isMemberSelected(member.id) }">
        <label
          v-if="paymentSelectMode && !isMemberPaid(member)"
          class="member-select-check"
          @click.stop
        >
          <input
            type="checkbox"
            :value="member.id"
            v-model="selectedMemberIds"
          >
        </label>
        <span class="sl-no">{{ index + 1 }}</span>

        <div class="avatar-section">
          <div class="avatar-wrap">
              <img v-if="member.avatar != 'member.jpg' && member.avatar != null"
                  :src="'https://guide.msoftit.com/' + member.avatar" alt="avatar" class="image">
              <img v-if="!member.avatar || member.avatar == 'member.jpg'"
                  :src="'assets/img/sample/avatar/avatar1.png'" alt="avatar" class="image">
              <span class="button-payment payment-verified" v-if="isMemberPaid(member)">
                  <ion-icon name="checkmark-circle"></ion-icon>
              </span>
          </div>
        </div>

        <div class="in">
          <div class="min-width-50">
            <div class="member-name-row">
              <b>{{ member.name }}</b>
              <span v-if="isMemberPaid(member)" class="payment-success-badge">
                <ion-icon name="checkmark-circle"></ion-icon>
                {{ $t('paid') }}
              </span>
            </div>
            <footer>
              {{ member.country_code }} {{ member.mobile }}
              <br>
                <span v-if="member.transfered_status" v-html="member.transfered_status"></span>
            </footer>
          </div>

          <div class="progress float-right" v-if="member.fillStatus > 0 && member.verified != 'Y'"
              :set="background_ = member.fillStatus >= 100 ? '#059205' : '#1a418c'">
              <div class="progress-bar" role="progressbar"
                  :style="{ width: member.fillStatus + '%', background: background_ }" aria-valuenow="85"
                  aria-valuemin="0" aria-valuemax="100">{{ member.fillStatus }}%</div>
          </div>

          <div class="card-button dropdown">
            <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
              :data-bs-target="'#actionSheetInset' + member.id" @click.stop="showActionModal">
              <ion-icon name="ellipsis-vertical-outline"></ion-icon>
            </button>
          </div>
        </div>
      </div>
    </li>
  </ul>

  <!-- Action modals outside list items (avoids nested anchors blocking payment navigation) -->
  <template v-if="!loadingList && wing === 1">
    <div
      v-for="member in filteredMembersList"
      :key="'member-modal-' + member.id"
      class="modal fade action-sheet"
      :id="'actionSheetInset' + member.id"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('action') }}</h5>
          </div>
          <div class="modal-body">
            <ul class="action-button-list">
              <li v-if="permissions.members?.update">
                <a href="javascript:void(0)" @click="editMember(member)" class="btn btn-list"
                  data-bs-dismiss="modal">
                  <span>
                    <ion-icon name="pencil-outline"></ion-icon> {{ $t('edit') }}
                  </span>
                </a>
              </li>
              <li v-if="permissions.members?.delete">
                <a href="javascript:void(0)" @click="initiateMemberDelete(member)" class="btn btn-list"
                  data-bs-dismiss="modal">
                  <span>
                    <ion-icon name="trash-outline"></ion-icon> {{ $t('remove') }}
                  </span>
                </a>
              </li>
              <li v-if="showMemberPaymentOption(member)">
                <a
                  href="javascript:void(0)"
                  class="btn btn-list"
                  @click.prevent="goToMemberPayment(member)"
                >
                  <span>
                    <ion-icon name="card-outline"></ion-icon> {{ $t('make_payment') }}
                  </span>
                </a>
              </li>
              <li>
                <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                  <span>
                    <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </template>

  <div v-if="!loadingList && wing === 2">
    <!-- Only show sections if there are executive members -->
    <div v-if="hasExecutiveMembers">
      <!-- Captain Section -->
      <div class="external-heading">
        <h6 class="section-title">{{ $t('captain') }}</h6>
      </div>
      <ul class="listview image-listview inset text mt-0 mb-2">
        <li v-if="currentCaptain" :style="{ 'background-color': getMemberBackgroundColor(currentCaptain) }">
          <a href="javascript:void(0)" class="item">
            <div class="avatar-section">
              <img :src="getMemberAvatar(currentCaptain)" alt="avatar" class="image">
            </div>
            <div class="in">
              <div class="min-width-50">
                <b>{{ currentCaptain.name }}</b>
                <footer>{{ currentCaptain.country_code }} {{ currentCaptain.mobile }}</footer>
              </div>
              <div class="card-button dropdown">
                <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                  :data-bs-target="'#actionSheetInset' + currentCaptain.id">
                  <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                </button>
              </div>
            </div>
          </a>
        </li>
      </ul>

      <!-- Vice Captain Section -->
      <div class="external-heading">
        <h6 class="section-title">{{ $t('vice_captain') }}</h6>
      </div>
      <ul class="listview image-listview inset text mt-0 mb-2">
        <li v-if="currentViceCaptain" :style="{ 'background-color': getMemberBackgroundColor(currentViceCaptain) }">
          <a href="javascript:void(0)" class="item">
            <div class="avatar-section">
              <img :src="getMemberAvatar(currentViceCaptain)" alt="avatar" class="image">
            </div>
            <div class="in">
              <div class="min-width-50">
                <b>{{ currentViceCaptain.name }}</b>
                <footer>{{ currentViceCaptain.country_code }} {{ currentViceCaptain.mobile }}</footer>
              </div>
              <div class="card-button dropdown">
                <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                  :data-bs-target="'#actionSheetInset' + currentViceCaptain.id">
                  <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                </button>
              </div>
            </div>
          </a>
        </li>
      </ul>

      <!-- Team Members Section -->
      <div class="external-heading">
        <h6 class="section-title">{{ $t('team_members') }} - {{ currentTeamMembers.length }}/7</h6>
      </div>
      <ul class="listview image-listview inset text mt-0 mb-2">
        <li v-for="(member, index) in currentTeamMembers" :key="member.id" 
          :style="{ 'background-color': getMemberBackgroundColor(member) }">
          <a href="javascript:void(0)" class="item">
            <span class="sl-no">{{ index + 1 }}</span>
            <div class="avatar-section">
              <img :src="getMemberAvatar(member)" alt="avatar" class="image">
            </div>
            <div class="in">
              <div class="min-width-50">
                <b>{{ member.name }}</b>
                <footer>{{ member.country_code }} {{ member.mobile }}</footer>
              </div>
              <div class="card-button dropdown">
                <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                  :data-bs-target="'#actionSheetInset' + member.id">
                  <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                </button>
              </div>
            </div>
          </a>
        </li>
      </ul>

      <!-- Action modals for each member -->
      <div v-for="member in allExecutiveMembers" :key="'modal-' + member.id" 
        class="modal fade action-sheet" :id="'actionSheetInset' + member.id" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('action') }}</h5>
            </div>
            <div class="modal-body">
              <ul class="action-button-list">
                <li v-if="permissions.members?.update">
                  <a href="javascript:void(0)" @click="removeFromTeam(member)" class="btn btn-list"
                    data-bs-dismiss="modal">
                    <span>
                      <ion-icon name="person-remove-outline"></ion-icon> {{ $t('remove_from_team') }}
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                    <span>
                      <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section text-center" v-if="!hasExecutiveMembers">
      <b>{{ $t('no_data') }}</b>
    </div>
  </div>

  <div class="section text-center" v-if="!loadingList && wing === 1 && filteredMembersList.length === 0">
    <b>{{ $t('no_data') }}</b>
  </div>

  <alert-model :type="alertType" :message="alertMessage" ref="alertModel"></alert-model>
  <dialog-model :message="dialogMessage" :action-method="dialogAction" :action-method-params="dialogActionParams"
    ref="dialogModel"></dialog-model>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";
import $ from 'jquery';
import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";

export default {
  name: 'BalavediList',

  components: {
    Form,
    Field,
    ErrorMessage,
    AlertModel,
    DialogModel,
  },

  props: {
    unitId: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      loading: false,
      loadingList: false,
      formData: {
        name: '',
        father_name: '',
        mobile: '',
        countryCode: '91',
        whatsapp: '',
        whatsappCountryCode: '91',
        age: '',
        school_name: '',
        school_class: ''
      },
      selectedMemberIds: [],
      paymentSelectMode: false,
      executiveFormData: {
        captain: '',
        vice_captain: '',
        team_members: []
      },
      membersList: [],
      filteredMembersList: [],
      originalMembersList: [],
      trashList: [],
      unit: {},
      wing: 1,
      editableId: null,
      isEditing: false,
      deleteData: {
        memberId: null,
        reason: '',
        otherReason: ''
      },
      deleteMessage: '',
      searchQuery: '',
      countryCodeList: [],
      countryList: [],
      permissions: {
        members: {}
      },
      madrasaId: null,
      madrasaName: '',
      alertType: '',
      alertMessage: '',
      dialogMessage: '',
      dialogAction: null,
      dialogActionParams: null,
      district_list: [],
      zone_list: [],
      unit_list: [],
      district_: '',
      zone_: '',
      unit_: '',
      madrasaData: null,

      validationSchema: yup.object().shape({
        name: yup
          .string()
          .matches(/^[a-zA-Z0-9&._-\s]*$/, this.$t('name_english_only'))
          .required(this.$t('enter_name_required')),
        father_name: yup
          .string()
          .matches(/^[a-zA-Z0-9&._-\s]*$/, this.$t('father_name_english_only'))
          .nullable()
          .notRequired(),
        mobile: yup
          .string()
          .required(this.$t('enter_mobile')),
        country_code: yup
          .string()
          .required(this.$t('enter_country_code')),
        whatsapp: yup
          .string()
          .nullable()
          .notRequired(),
        whatsapp_country_code: yup
          .string()
          .nullable()
          .notRequired(),
        age: yup
          .number()
          .min(1, this.$t('age_minimum'))
          .nullable()
          .notRequired()
          .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
          }),
        school_name: yup
          .string()
          .nullable()
          .notRequired(),
        school_class: yup
          .string()
          .nullable()
          .notRequired(),
      }),

      executiveValidationSchema: yup.object().shape({
        captain: yup.string().nullable(),
        vice_captain: yup.string().nullable(),
        team_members: yup.array().max(7, this.$t('maximum_7_team_members'))
      }),

      // Delete reasons
      deleteReasons: [
        { value: this.$t('delete_reason_1'), label: this.$t('delete_reason_1') },
        { value: this.$t('delete_reason_2'), label: this.$t('delete_reason_2') },
        { value: this.$t('delete_reason_3'), label: this.$t('delete_reason_3') },
        { value: this.$t('delete_reason_4'), label: this.$t('delete_reason_4') },
        { value: this.$t('delete_reason_5'), label: this.$t('delete_reason_5') },
        { value: this.$t('delete_reason_6'), label: this.$t('delete_reason_6') },
        { value: this.$t('delete_reason_7'), label: this.$t('delete_reason_7') },
        { value: this.$t('delete_reason_8'), label: this.$t('delete_reason_8') },
        { value: this.$t('delete_reason_9'), label: this.$t('delete_reason_9') },
        { value: this.$t('delete_reason_other'), label: this.$t('delete_reason_other') }
      ]
    };
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },

    canUpdateMembers() {
      return ((this.permissions.members?.update) || this.madrasaId);
    },

    showOtherReasonField() {
      return this.deleteData.reason === 'Other';
    },

    availableMembers() {
      return this.membersList.filter(member => member.wing == 5 || member.wing == 1);
    },

    currentCaptain() {
      return this.membersList.find(member => member.balavedi_role === 'captain');
    },

    currentViceCaptain() {
      return this.membersList.find(member => member.balavedi_role === 'vice_captain');
    },

    currentTeamMembers() {
      return this.membersList.filter(member => member.balavedi_role === 'team_member');
    },

    allExecutiveMembers() {
      return this.membersList.filter(member => 
        member.balavedi_role === 'captain' || 
        member.balavedi_role === 'vice_captain' || 
        member.balavedi_role === 'team_member'
      );
    }, 

    hasUnpaidMembers() {
      return this.filteredMembersList.some(member => !this.isMemberPaid(member));
    },

    hasExecutiveMembers() {
      return this.currentCaptain || this.currentViceCaptain || this.currentTeamMembers.length > 0;
    },
  },

  mounted() {
    this.initializeComponent();
  },

  activated() {
    if (this.madrasaId && this.wing === 1) {
      this.getMadrasaMembers(1);
    }
  },

  methods: {
    async initializeComponent() {
      if (!this.currentUser) {
        location.replace('/');
        return;
      }

      this.madrasaId = this.$route.params.madrasa_id;
      
      // Load district list for all users
      await this.getDistrictList();
      
      if (this.$route.params.sub_level == 1) {
        this.getDistrictList(this.$route.params.id);
      }
      if (this.$route.params.sub_level == 2) {
        this.getZoneList(this.$route.params.id);
      }
      if (this.$route.params.sub_level == 3) {
        this.getUnitList(this.$route.params.id);
      }

      if (this.madrasaId) {
        await this.getMadrasaMembers(1);
        this.$root.updateParent('Balavedi Members');
      } else {
        await this.getMembersList(1);
        this.$root.updateParent('Balavedi List');
      }

      await Promise.all([
        this.getComboboxValues('COUNTRY'),
        this.getComboboxValues('COUNTRY_CODE'),
      ]);

      this.setupPopstateHandler();
    },

    setupPopstateHandler() {
      window.onpopstate = () => {
        if ($('body').hasClass('modal-open')) {
          location.reload();
        }
      };
    },

    isMemberPaid(member) {
      const paymentStatus = String(member?.payment_status || member?.fee_status || '').toLowerCase();
      if (paymentStatus === 'paid' || member?.feePaid === 'Y') {
        return true;
      }
      // Balavedi madrasa: 100% membership completion counts as paid
      if (this.madrasaId && this.wing === 1 && Number(member?.fillStatus) >= 100) {
        return true;
      }
      return false;
    },

    showMemberPaymentOption(member) {
      if (!member?.id || this.wing !== 1) return false;
      return !this.isMemberPaid(member);
    },

    getMemberPaymentUrl(memberOrIds) {
      const memberIds = Array.isArray(memberOrIds)
        ? memberOrIds.filter(Boolean)
        : [memberOrIds?.id].filter(Boolean);
      if (!memberIds.length) return null;

      const userId = Array.isArray(memberOrIds)
        ? this.currentUser?.id
        : (memberOrIds?.user_id || this.currentUser?.id);
      if (!userId) return null;

      const params = new URLSearchParams({
        gway: 'payu',
        user_id: String(userId),
        member_id: memberIds.join(','),
      });
      if (memberIds.length > 1) {
        params.set('bulk', '1');
      }
      if (this.$route?.fullPath) {
        params.set('return_url', `https://guide.wisdomislam.org/#${this.$route.fullPath}`);
      }
      return `https://guide.msoftit.com/payment?${params.toString()}`;
    },

    isMemberSelected(memberId) {
      return this.selectedMemberIds.includes(memberId);
    },

    togglePaymentSelectMode() {
      this.paymentSelectMode = !this.paymentSelectMode;
      if (!this.paymentSelectMode) {
        this.selectedMemberIds = [];
      }
    },

    goToBulkPayment() {
      const unpaidSelected = this.selectedMemberIds.filter(id => {
        const member = this.filteredMembersList.find(m => m.id === id);
        return member && !this.isMemberPaid(member);
      });
      if (!unpaidSelected.length) {
        this.$swal('Error', 'Please select at least one unpaid member.', 'error');
        return;
      }
      const url = this.getMemberPaymentUrl(unpaidSelected);
      if (!url) {
        this.$swal('Error', 'Payment link is not available.', 'error');
        return;
      }
      window.location.href = url;
    },

    goToMemberPayment(member) {
      const url = this.getMemberPaymentUrl(member);
      if (!url) {
        this.$swal('Error', 'Payment link is not available for this member.', 'error');
        return;
      }
      const modalEl = document.getElementById(`actionSheetInset${member.id}`);
      if (modalEl) {
        const Modal = window.bootstrap?.Modal;
        if (Modal) {
          const instance = Modal.getInstance(modalEl) || new Modal(modalEl);
          instance.hide();
        } else {
          $(modalEl).modal('hide');
        }
      }
      window.location.href = url;
    },

    async getComboboxValues(code, id = null) {
      try {
        const data = { code, type_id: id };
        const response = await UserService.getCombobox(data);

        switch (code) {
          case 'COUNTRY_CODE':
            this.countryCodeList = response.data.data.list.options;
            break;
          case 'COUNTRY':
            this.countryList = response.data.data.list.options;
            break;
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async getMadrasaMembers(wing) {
      try {
        this.loadingList = true;
        this.wing = wing;
        this.selectedMemberIds = [];
        this.paymentSelectMode = false;

        const response = await UserService.authGetRequest(`balavedi/members/madrassa/${this.madrasaId}`);

        if (response.data.status === 'success') {
          const responseData = response.data.data || {};
          const allMembers = Array.isArray(responseData.members) ? responseData.members : [];

          if (wing === 1) {
            // Show regular members (wing 5 or 1, excluding those with executive roles)
            const filteredMembers = allMembers.filter(member => 
              (member.wing == 5 || member.wing == 1 || member.wing === null || member.wing === undefined) &&
              !member.balavedi_role
            );
            this.setMemberData(filteredMembers, allMembers);
          } else if (wing === 2) {
            // Show all members for executive team structure
            this.setMemberData(allMembers, allMembers);
          }

          // Store madrasa data for form defaults
          if (responseData.madrassa) {
            this.madrasaData = responseData.madrassa;
            this.madrasaName = responseData.madrassa.name;
            
            this.district_ = responseData.madrassa.district_id;
            this.zone_ = responseData.madrassa.zone_id;
            this.unit_ = responseData.madrassa.unit_id;
            
            if (this.district_) {
              await this.getZoneList(this.district_);
            }
            if (this.zone_) {
              await this.getUnitList(this.zone_);
            }
          }
        } else {
          console.log('API response not successful:', response.data);
          this.setEmptyMemberData();
        }
      } catch (error) {
        console.error('Error fetching madrasa members:', error);
        this.setEmptyMemberData();
      } finally {
        this.loadingList = false;
      }
    },

    async getMembersList(wing) {
      if (this.madrasaId) {
        return this.getMadrasaMembers(wing);
      }

      try {
        this.loadingList = true;
        this.wing = wing;
        this.selectedMemberIds = [];
        this.paymentSelectMode = false;
        const data = {
          unit_id: this.unitId || this.currentUser.unit_id,
          wing,
          members_list: false,
          temp_members_list: true,
          user_level: this.$route.params.sub_level,
          user_level_id: this.$route.params.id
        };

        const response = await UserService.authPostRequest('get-members', data);

        if (response.data.status === 'success') {
          this.membersList = response.data.data.list;
          this.filteredMembersList = response.data.data.temp_list;
          this.originalMembersList = response.data.data.list;
          this.trashList = response.data.data.trash_list;
          this.unit = response.data.data.unit;
          this.wing = wing;
          this.permissions = response.data.data.permissions;
          this.searchQuery = '';
        } else {
          this.$swal('', response.data.message, 'error');
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loadingList = false;
      }
    },

    async addMember(formValues) {
      try {
        this.loading = true;

        if (!this.madrasaId) {
          this.$swal('Error', 'Madrasa ID is required', 'error');
          return;
        }

        const memberData = this.prepareMemberData(formValues);
        console.log('Sending member data:', memberData);
        const response = await UserService.authPostRequest('balavedi/members/create-or-update', memberData);
        console.log('API Response:', response);

        if (response.data.status === 'success') {
          $('#addMemberModel').modal('hide');
          this.$swal('Success', response.data.message || 'Member saved successfully', 'success');
          this.resetForm();
          await this.getMadrasaMembers(this.wing);
        } else {
          const errorMessage = response.data.message || 'Failed to save member';
          if (response.data.errors) {
            const firstError = Object.values(response.data.errors)[0];
            this.$swal('Validation Error', Array.isArray(firstError) ? firstError[0] : firstError, 'error');
          } else {
            this.$swal('Error', errorMessage, 'error');
          }
        }
      } catch (error) {
        console.error('Error saving member:', error);
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          if (errorData.errors) {
            // Validation errors
            const firstError = Object.values(errorData.errors)[0];
            this.$swal('Validation Error', Array.isArray(firstError) ? firstError[0] : firstError, 'error');
          } else {
            this.$swal('Error', errorData.message || 'Failed to save member', 'error');
          }
        } else {
          this.$swal('Error', 'Network error. Please try again.', 'error');
        }
      } finally {
        this.loading = false;
      }
    },

    prepareMemberData(formValues) {
      const memberData = {
        name: formValues.name,
        father_name: formValues.father_name,
        mobile: formValues.mobile,
        country_code: formValues.country_code,
        age: formValues.age ? parseInt(formValues.age) : null,
        school_name: formValues.school_name || null,
        school_class: formValues.school_class || null,
        madrassa_id: parseInt(this.madrasaId),
        wing: this.wing === 1 ? 5 : this.wing,
        district_id: this.district_ || null,
        zone_id: this.zone_ || null,
        unit_id: this.unit_ || null,
      };

      if (formValues.whatsapp) {
        memberData.whatsapp = formValues.whatsapp;
        memberData.whatsapp_country_code = formValues.whatsapp_country_code || '91';
      }

      if (this.editableId) {
        memberData.id = this.editableId;
      }

      console.log('Prepared member data:', memberData);
      return memberData;
    },

    async confirmMemberDelete() {
      if (!this.deleteData.reason) {
        this.deleteMessage = 'ഡിലീറ്റ് ചെയ്യാനുള്ള കാരണം സെലക്ട് ചെയ്യുക';
        return;
      }

      try {
        this.loading = true;
        this.deleteMessage = '';

        const deleteReason = this.showOtherReasonField ? this.deleteData.otherReason : this.deleteData.reason;
        const data = {
          id: this.deleteData.memberId,
          reason: deleteReason
        };

        const endpoint = this.madrasaId ? 'balavedi/members/delete' : 'delete-members';
        const response = await UserService.authPostRequest(endpoint, data);

        if (response.data.status === 'success' || response.data.status === 'warning') {
          this.resetDeleteData();
          $('#deleteMemberModel').modal('hide');

          const messageType = response.data.status === 'success' ? 'success' : 'warning';
          this.$swal(messageType.charAt(0).toUpperCase() + messageType.slice(1), response.data.message, messageType);

          if (this.madrasaId) {
            await this.getMadrasaMembers(this.wing);
          } else {
            await this.getMembersList(this.wing);
          }
        } else {
          this.$swal('Error', response.data.message, 'error');
        }
      } catch (error) {
        console.error('Error deleting member:', error);
        this.$swal('Error', 'Failed to delete member', 'error');
      } finally {
        this.loading = false;
      }
    },

    openAddMemberModal() {
      $('#addMemberModel').modal('show');
      this.resetForm();
      this.isEditing = false;
      
      if (this.madrasaData) {
        this.district_ = this.madrasaData.district_id || '';
        this.zone_ = this.madrasaData.zone_id || '';
        this.unit_ = this.madrasaData.unit_id || '';
        
        if (this.district_ && this.zone_list.length === 0) {
          this.getZoneList(this.district_);
        }
        if (this.zone_ && this.unit_list.length === 0) {
          this.getUnitList(this.zone_);
        }
      }
    },

    closeAddMemberModal() {
      $('#addMemberModel').modal('hide');
    },

    editMember(member) {
      if (this.wing === 1) {
        $('#addMemberModel').modal('show');
        this.populateForm(member);
      } else if (this.wing === 2) {
        $('#addExecutiveModel').modal('show');
        this.populateExecutiveForm(member);
      }
      this.isEditing = true;
    },

    initiateMemberDelete(member) {
      this.deleteData.memberId = member.id;
      $('#deleteMemberModel').modal('show');
    },

    onCountryCodeChange() {
      console.log('Country code changed to:', this.formData.countryCode);
    },

    formatMobileNumber(event) {
      let value = event.target.value.replace(/[\s/]/g, '');
      if (value.charAt(0) === '0') {
        value = value.slice(1, 13);
      }
      if (value.length > 12) {
        value = value.slice(0, 12);
      }
      this.formData.mobile = value;
    },

    formatWhatsAppNumber(event) {
      let value = event.target.value.replace(/[\s/]/g, '');
      if (value.charAt(0) === '0') {
        value = value.slice(1, 13);
      }
      if (value.length > 12) {
        value = value.slice(0, 12);
      }
      this.formData.whatsapp = value;
    },

    filterMembers() {
      this.loadingList = true;

      if (!this.searchQuery.trim()) {
        this.filteredMembersList = [...this.originalMembersList];
      } else {
        const searchTerms = this.searchQuery.toLowerCase().split(' ');

        this.filteredMembersList = this.originalMembersList.filter(member => {
          const name = member.name.toLowerCase();
          const mobile = member.mobile.toLowerCase();

          return searchTerms.every(term =>
            name.includes(term) || mobile.includes(term)
          );
        });
      }

      this.loadingList = false;
    },

    // Helper methods
    setMemberData(filteredMembers, allMembers = null) {
      this.membersList = filteredMembers;
      this.filteredMembersList = filteredMembers;
      this.originalMembersList = filteredMembers;
      this.searchQuery = '';

      if (allMembers) {
        this.unit = {
          wisdom_count: allMembers.filter(m => m.wing == 1).length,
          youth_count: allMembers.filter(m => m.wing == 2).length
        };
      }

      this.permissions = {
        members: {
          view: true,
          update: true,
          delete: true,
          call: true,
          whatsapp: true,
          payments: true,
        }
      };
    },

    setEmptyMemberData() {
      this.membersList = [];
      this.filteredMembersList = [];
      this.originalMembersList = [];
      this.unit = { wisdom_count: 0, youth_count: 0 };
      this.permissions = {
        members: {
          view: true,
          update: true,
          delete: true,
          call: true,
          whatsapp: true,
          payments: true,
        }
      };
    },

    resetForm() {
      this.formData = {
        name: '',
        father_name: '',
        mobile: '',
        countryCode: '91',
        whatsapp: '',
        whatsappCountryCode: '91',
        age: '',
        school_name: '',
        school_class: ''
      };
      this.editableId = null;
      this.selectedMemberIds = [];
      this.paymentSelectMode = false;

      if (!this.madrasaData) {
        this.district_ = '';
        this.zone_ = '';
        this.unit_ = '';
      }
    },

    populateForm(member) {
      this.formData.name = member.name || '';
      this.formData.father_name = member.father_name || '';
      this.formData.mobile = member.mobile || '';
      this.formData.countryCode = member.country_code || '91';
      this.formData.age = member.age || '';
      this.formData.school_name = member.school_name || '';
      this.formData.school_class = member.school_class || '';
      this.formData.whatsapp = member.whatsapp || '';
      this.formData.whatsappCountryCode = member.whatsapp_country_code || '91';
      this.editableId = member.id;

      this.district_ = member.district_id || (this.madrasaData ? this.madrasaData.district_id : '');
      this.zone_ = member.zone_id || (this.madrasaData ? this.madrasaData.zone_id : '');
      this.unit_ = member.unit_id || (this.madrasaData ? this.madrasaData.unit_id : '');
      
      if (this.district_) {
        this.getZoneList(this.district_);
      }
      if (this.zone_) {
        this.getUnitList(this.zone_);
      }

      console.log('Form populated with:', this.formData);
    },

    resetDeleteData() {
      this.deleteData = {
        memberId: null,
        reason: '',
        otherReason: ''
      };
      this.deleteMessage = '';
    },

    // UI helper methods
    getMemberBackgroundColor() {
      return '#ffffff';
    },

    getMemberAvatar(member) {
      if (member.avatar && member.avatar !== 'member.jpg') {
        return `https://guide.msoftit.com/${member.avatar}`;
      }
      return 'assets/img/sample/avatar/avatar1.png';
    },

    getProgressBarColor(fillStatus) {
      return fillStatus >= 100 ? '#059205' : '#1a418c';
    },

    getWhatsAppUrl(member) {
      if (!member.whatsapp) return '#';
      return `https://wa.me/${member.whatsapp_country_code}${member.whatsapp}?text=`;
    },

    // Error handling
    handleError(error) {
      this.loading = false;
      const message = (error.response?.data?.message) ||
        error.message ||
        error.toString();
      console.error('API Error:', message);
    },

    onDeleteReasonChange() {
      console.log('Delete reason changed:', this.deleteData.reason);
    },

    showActionModal() {
      console.log('Action modal opened');
    },

    async getDistrictList() {
      try {
        let data = {};
        const response = await UserService.authPostRequest(`get-district-by-id`, data);
        
        if (response.data.status === 'success') {
          this.district_list = response.data.data.list;
          console.log('District list loaded:', this.district_list);
        } else {
          this.district_list = [];
          console.log('No districts found');
        }
        return response;
      } catch (error) {
        console.error('Error loading districts:', error);
        this.district_list = [];
        this.handleError(error);
        throw new Error("Failed to fetch district list");
      }
    },
    async getZoneList(district_id) {
      try {
        let data = {
          district_id: district_id
        };
        const response = await UserService.authPostRequest(`get-zone-by-id`, data);
        
        if (response.data.status == 'success') {
          this.zone_list = response.data.data.list;
          console.log('Zone list loaded:', this.zone_list);
        } else {
          this.zone_list = [];
        }
      } catch (error) {
        console.error('Error loading zones:', error);
        this.zone_list = [];
        this.handleError(error);
      }
    },
    async getUnitList(zone_id) {
      try {
        let data = {
          zone_id: zone_id
        };
        const response = await UserService.authPostRequest(`get-unit-by-id`, data);
        
        if (response.data.status == 'success') {
          this.unit_list = response.data.data.list;
          console.log('Unit list loaded:', this.unit_list);
        } else {
          this.unit_list = [];
        }
      } catch (error) {
        console.error('Error loading units:', error);
        this.unit_list = [];
        this.handleError(error);
      }
    },

    onDistrictChange(districtId) {
      console.log('District changed to:', districtId);
      this.district_ = districtId;
      if (districtId) {
        this.getZoneList(districtId);
      } else {
        this.zone_list = [];
        this.unit_list = [];
        this.zone_ = '';
        this.unit_ = '';
      }
    },

    onZoneChange(zoneId) {
      console.log('Zone changed to:', zoneId);
      this.zone_ = zoneId;
      if (zoneId) {
        this.getUnitList(zoneId);
      } else {
        this.unit_list = [];
        this.unit_ = '';
      }
    },

    // The Team Members checkboxes are plain <input> elements, not vee-validate <Field>s (unlike
    // captain/vice_captain), so the <Form>'s own `formValues` argument never has team_members on
    // it — reading it here threw "Cannot read properties of undefined (reading 'length')" before
    // the request could even be sent. this.executiveFormData (kept in sync via v-model for all
    // three fields) is the actual source of truth, so use that instead of the Form's formValues.
    async addExecutive() {
      try {
        this.loading = true;

        if (!this.madrasaId) {
          this.$swal('Error', 'Madrasa ID is required', 'error');
          return;
        }

        if (this.executiveFormData.team_members.length > 7) {
          this.$swal('Error', 'Maximum 7 team members allowed', 'error');
          return;
        }

        const executiveData = this.prepareExecutiveData();
        console.log('Sending executive data:', executiveData);
        
        const response = await UserService.authPostRequest('balavedi/assign-team-roles', executiveData);
        console.log('API Response:', response);

        if (response.data.status === 'success') {
          $('#addExecutiveModel').modal('hide');
          this.$swal('Success', response.data.message || 'Team structure updated successfully', 'success');
          this.resetExecutiveForm();
          // Refresh the executive listing to show updated team structure
          await this.getMadrasaMembers(2);
        } else {
          const errorMessage = response.data.message || 'Failed to update team structure';
          this.$swal('Error', errorMessage, 'error');
        }
      } catch (error) {
        console.error('Error updating team structure:', error);
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          this.$swal('Error', errorData.message || 'Failed to update team structure', 'error');
        } else if (error.request) {
          // A real axios request went out and got no response at all — an actual network failure.
          this.$swal('Error', 'Network error. Please try again.', 'error');
        } else {
          // Not an HTTP error at all (e.g. a JS bug before the request was even sent) — show the
          // real message instead of the misleading "Network error", so this is debuggable from
          // the UI next time instead of looking identical to a connectivity problem.
          this.$swal('Error', error.message || 'Something went wrong. Please try again.', 'error');
        }
      } finally {
        this.loading = false;
      }
    },

    prepareExecutiveData() {
      const executiveData = {
        madrassa_id: parseInt(this.madrasaId),
        captain: this.executiveFormData.captain || null,
        vice_captain: this.executiveFormData.vice_captain || null,
        team_members: this.executiveFormData.team_members || []
      };

      console.log('Prepared executive data:', executiveData);
      return executiveData;
    },

    resetExecutiveForm() {
      this.executiveFormData = {
        captain: '',
        vice_captain: '',
        team_members: []
      };
    },

    populateExecutiveForm() {
      this.executiveFormData.captain = this.currentCaptain ? this.currentCaptain.id.toString() : '';
      this.executiveFormData.vice_captain = this.currentViceCaptain ? this.currentViceCaptain.id.toString() : '';
      this.executiveFormData.team_members = this.currentTeamMembers.map(member => member.id.toString());
    },

    openAddExecutiveModal() {
      $('#addExecutiveModel').modal('show');
      this.populateExecutiveForm(); // Load current structure
      this.isEditing = false;
    },

    closeAddExecutiveModal() {
      $('#addExecutiveModel').modal('hide');
    },

    isCurrentlyAssigned(memberId, excludeRole = null) {
      const member = this.membersList.find(m => m.id == memberId);
      if (!member || !member.balavedi_role) return false;
      
      if (excludeRole && member.balavedi_role === excludeRole) return false;
      
      return ['captain', 'vice_captain', 'team_member'].includes(member.balavedi_role);
    },

    // Role management methods
    getRoleCount(role) {
      return this.membersList.filter(member => member.balavedi_role === role).length;
    },

    isTeamMemberDisabled(memberId) {
      // Disable if already captain or vice captain
      if (this.executiveFormData.captain == memberId || this.executiveFormData.vice_captain == memberId) {
        return true;
      }
      
      // Disable if max team members reached and not currently selected
      if (this.executiveFormData.team_members.length >= 7 && 
          !this.executiveFormData.team_members.includes(memberId.toString())) {
        return true;
      }
      
      return false;
    },

    onTeamMemberChange() {
      // Ensure we don't exceed 7 members
      if (this.executiveFormData.team_members.length > 7) {
        this.executiveFormData.team_members = this.executiveFormData.team_members.slice(0, 7);
      }
    },

    async removeFromTeam(member) {
      try {
        const result = await this.$swal({
          title: 'Remove from Team?',
          text: `Are you sure you want to remove ${member.name} from the Balavedi team?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, remove',
          cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
          this.loading = true;
          
          const data = {
            madrassa_id: parseInt(this.madrasaId),
            member_id: member.id,
            action: 'remove'
          };

          const response = await UserService.authPostRequest('balavedi/remove-team-member', data);

          if (response.data.status === 'success') {
            this.$swal('Success', 'Member removed from team successfully', 'success');
            await this.getMadrasaMembers(this.wing);
          } else {
            this.$swal('Error', response.data.message || 'Failed to remove member', 'error');
          }
        }
      } catch (error) {
        console.error('Error removing team member:', error);
        this.$swal('Error', 'Failed to remove member from team', 'error');
      } finally {
        this.loading = false;
      }
    },

    isRoleDisabled(role) {
      if (this.isEditing) {
        // Allow current role when editing
        const currentMember = this.membersList.find(m => m.id === this.editableId);
        if (currentMember && currentMember.balavedi_role === role) {
          return false;
        }
      }

      if (role === 'captain') {
        return this.getRoleCount('captain') >= 1;
      } else if (role === 'vice_captain') {
        return this.getRoleCount('vice_captain') >= 1;
      } else if (role === 'team_member') {
        return this.getRoleCount('team_member') >= 7;
      }
      return false;
    },

    openAddModal() {
      if (this.wing === 1) {
        this.openAddMemberModal();
      } else if (this.wing === 2) {
        this.openAddExecutiveModal();
      }
    },

    canAddRole(role) {
      if (!role) return false;
      return !this.isRoleDisabled(role);
    },

    getBalavediRoleLabel(role) {
      const roleObj = this.balaveديRoles.find(r => r.value === role);
      return roleObj ? roleObj.label : role;
    },

    getRoleBadgeClass(role) {
      switch (role) {
        case 'captain':
          return 'badge-captain';
        case 'vice_captain':
          return 'badge-vice-captain';
        case 'team_member':
          return 'badge-team-member';
        default:
          return 'badge-secondary';
      }
    },

    onBalavediRoleChange() {
      console.log('Balavedi role changed to:', this.executiveFormData.balavedi_role);
    },
  }
};
</script>

<style scoped>
.section {
  margin-bottom: 1rem;
}

.error-feedback {
  color: #dc3545;
  font-size: 0.875em;
  margin-top: 0.25rem;
}

.mal-text {
  color: #6c757d;
  font-style: italic;
}

.listview {
  margin-bottom: 1rem;
}

.listview>li footer {
  color: #171617;
}

.min-width-50 {
  min-width: 60% !important;
}

.sl-no {
  font-weight: 900;
  margin-right: 12px;
  color: #495057;
}

.image-listview.text>li:after {
  left: 0px;
  background-color: #1a418c;
}

.avatar-section {
  position: relative;
}

.avatar-section .button {
  color: #fff;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  position: absolute;
  right: 10px;
  top: 24px;
}

.avatar-section .verified {
  background: #28a745;
}

.avatar-section .not-verified {
  background: #dc3545;
}

.action-button-list>li {
  min-height: 44px !important;
  border-bottom: 1px solid #f1f1f1;
}

.action-button-list>li:last-child {
  border-bottom: none;
}

.tab-container-1 {
  margin: 1.5rem 0 1rem 0;
}

.pill-tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  max-width: 600px;
  margin: 0 auto;
}

.pill-tab {
  flex: 1 1 140px;
  min-width: 120px;
  max-width: 200px;
  padding: 0.6rem 1rem;
  border: none;
  border-radius: 999px;
  background: #f5f7fa;
  color: #1a418c;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s, color.18s, box-shadow 0.18s;
  outline: none;
  box-shadow: 0 1px 3px rgba(26, 65, 140, 0.04);
  margin: 0;
  text-align: center;
  white-space: nowrap;
}

.pill-tab.active,
.pill-tab:focus {
  background: #1a418c;
  color: #fff;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(26, 65, 140, 0.10);
}

.pill-tab:focus {
  box-shadow: 0 0 0 3px rgba(26, 65, 140, 0.25);
}

.searchbox {
  position: relative;
}

.searchbox .input-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 18px;
  pointer-events: none;
}

.searchbox input {
  padding-right: 40px;
}

.btn-primary {
  background-color: #1a418c;
  border-color: #1a418c;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #153a7a;
  border-color: #153a7a;
  transform: translateY(-1px);
}

.btn-primary:disabled {
  opacity: 0.6;
  transform: none;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  margin-right: 0.5rem;
}

@media (max-width: 768px) {
  .pill-tabs {
    max-width: 100%;
    gap: 0.75rem;
  }

  .pill-tab {
    flex: 1 1 120px;
    min-width: 100px;
    font-size: 0.9rem;
    padding: 0.6rem 1rem;
  }

  .min-width-50 {
    min-width: 50% !important;
  }

}

@media (max-width: 480px) {
  .pill-tabs {
    gap: 0.5rem;
  }

  .pill-tab {
    flex: 1 1 100px;
    font-size: 0.85rem;
    padding: 0.5rem 0.75rem;
  }

  .sl-no {
    font-size: 0.9rem;
    margin-right: 8px;
  }

  .avatar-section .button {
    width: 16px;
    height: 16px;
    font-size: 10px;
    right: 8px;
    top: 20px;
  }
}

.btn:focus,
.form-control:focus,
.custom-select:focus {
  box-shadow: 0 0 0 3px rgba(26, 65, 140, 0.25);
}

.listview>li {
  transition: background-color 0.3s ease;
}

.listview>li:hover {
  background-color: #f8f9fa !important;
}

.modal-header {
  border-bottom: 2px solid #e9ecef;
  padding: 1rem 1.5rem;
}

.modal-title {
  color: #1a418c;
  font-weight: 600;
}

.modal-body {
  padding: 1.5rem;
}

.list-group-title {
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  font-weight: 600;
  color: #495057;
  padding: 12px 16px;
  margin: 8px 0 0 0;
  font-size: 0.95rem;
}

.list-group-title:first-child {
  margin-top: 0;
}

.no-member {
  padding: 12px 16px;
  text-align: center;
  font-style: italic;
  color: #6c757d;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.external-heading {
  margin: 20px 0 8px 0;
  padding: 0 16px;
}

.section-title {
    font-size: 15px;
    padding: 0px 20px;
    color: #27173E;
    font-weight: 500;
}

/* Remove the old list-group-title styles since headings are now external */
.list-group-title {
  display: none;
}

/* Adjust list margins to work with external headings */
.listview.image-listview.inset.text {
  margin-top: 0 !important;
  margin-bottom: 12px !important;
}

/* No member message styling */
.no-member {
  padding: 16px;
  text-align: center;
  font-style: italic;
  color: #6c757d;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .external-heading {
    margin: 16px 0 6px 0;
    padding: 0 12px;
  }
  
  .section-title {
    font-size: 1rem;
    min-width: 180px;
  }
}

@media (max-width: 480px) {
  .external-heading {
    margin: 12px 0 4px 0;
    padding: 0 8px;
  }
  
  .section-title {
    font-size: 0.95rem;
    min-width: 160px;
  }
}

.member-selection-container {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 8px;
  background: #f8f9fa;
}

/* Checkbox item styling */
.member-checkbox-item {
  margin-bottom: 8px;
}

.member-checkbox-item:last-child {
  margin-bottom: 0;
}

/* Checkbox label styling */
.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  margin: 0;
  font-weight: 400;
}

.checkbox-label:hover {
  background-color: #e9ecef;
}

/* Checkbox input styling */
.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin: 0;
  margin-right: 12px;
  cursor: pointer;
  flex-shrink: 0;
}

/* Custom checkmark styling (optional) */
.checkmark {
  display: none; /* Hide if using default checkbox */
}

/* Member info styling */
.member-info {
  flex: 1;
  font-size: 14px;
  color: #495057;
  line-height: 1.4;
}

/* Disabled state */
.checkbox-label input[type="checkbox"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.checkbox-label input[type="checkbox"]:disabled + .member-info {
  opacity: 0.5;
  color: #6c757d;
}

/* Selected state */
.checkbox-label input[type="checkbox"]:checked + .checkmark + .member-info {
  font-weight: 500;
  color: #1a418c;
}

/* Focus state for accessibility */
.checkbox-label input[type="checkbox"]:focus {
  outline: 2px solid #1a418c;
  outline-offset: 2px;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .member-selection-container {
    max-height: 150px;
  }
  
  .checkbox-label {
    padding: 6px 10px;
  }
  
  .checkbox-label input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  
  .member-info {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .checkbox-label {
    padding: 6px 8px;
  }
  
  .checkbox-label input[type="checkbox"] {
    margin-right: 8px;
  }
  
  .member-info {
    font-size: 12px;
  }
}

.avatar-section .button-payment {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 5px;
    bottom: 0;
}

.avatar-section .payment-verified {
    background: #05d0a4;
}

.member-name-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.payment-success-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #059205;
  background: rgba(5, 146, 5, 0.12);
  border: 1px solid rgba(5, 146, 5, 0.35);
  border-radius: 12px;
  padding: 2px 8px;
  line-height: 1.2;
}

.payment-success-badge ion-icon {
  font-size: 14px;
}

.member-select-check {
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
  flex-shrink: 0;
}

.member-select-check input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.balavedi-members-toolbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.balavedi-members-toolbar-search {
  width: 100%;
}

.balavedi-members-toolbar-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  width: 100%;
}

.balavedi-toolbar-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 38px;
  padding: 6px 10px;
  font-size: 13px;
  line-height: 1.25;
  white-space: normal;
  text-align: center;
  width: 100%;
  margin: 0;
}

.balavedi-toolbar-btn ion-icon {
  font-size: 16px;
  flex-shrink: 0;
}

.balavedi-toolbar-btn:only-child {
  grid-column: 1 / -1;
}

.balavedi-toolbar-btn:last-child:nth-child(odd):not(:only-child) {
  grid-column: 1 / -1;
}

@media (min-width: 576px) {
  .balavedi-members-toolbar {
    flex-direction: row;
    align-items: stretch;
    flex-wrap: wrap;
  }

  .balavedi-members-toolbar-search {
    flex: 1 1 220px;
    min-width: 0;
  }

  .balavedi-members-toolbar-actions {
    flex: 0 1 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: auto;
    max-width: 100%;
  }

  .balavedi-toolbar-btn {
    width: auto;
    white-space: nowrap;
    flex: 0 0 auto;
  }

  .balavedi-toolbar-btn:only-child,
  .balavedi-toolbar-btn:last-child:nth-child(odd):not(:only-child) {
    grid-column: auto;
  }
}

.item-selected {
  background: rgba(26, 65, 140, 0.06);
}
</style>